import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconVk: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M11.89 15.39h.69a.37.37 0 0 0 .31-.16c.08-.08.08-.31.08-.31s0-1 .46-1.08 1 .93 1.62 1.39a1 1 0 0 0 .77.23h1.62s.84-.07.46-.69c0-.08-.23-.46-1.23-1.39s-.85-.77.31-2.39c.77-1 1.07-1.61.92-1.85.08-.38-.46-.3-.46-.3h-1.85a.39.39 0 0 0-.23.07 1.2 1.2 0 0 0-.16.23 10.24 10.24 0 0 1-.69 1.39c-.77 1.39-1.08 1.47-1.23 1.39-.31-.23-.23-.77-.23-1.23 0-1.31.23-1.93-.39-2a1.92 1.92 0 0 0-.85-.15 4.42 4.42 0 0 0-1.54.15c-.15.16-.31.31-.23.39a.65.65 0 0 1 .54.31 2.17 2.17 0 0 1 .15.84s.08 1.54-.23 1.78c-.23 0-.61-.24-1.31-1.47a9.25 9.25 0 0 1-.61-1.39L8.42 9a.48.48 0 0 0-.31-.15H6.42A.63.63 0 0 0 6 9v.3a22.16 22.16 0 0 0 2.86 4.78 4 4 0 0 0 3 1.31z"
    />
  </Svg>
)
